export const envToBoolean = (prop: string, def: boolean): boolean => {
    switch (prop.toLowerCase()) {
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return def;
    }
};

export const envToNumber = (prop: string, def: number): number => {
    const val = Number(prop);
    if (val || val === 0) {
        return val;
    }
    return def;
};
